import React from 'react'

import OpaqueDropdownMenuItem from '@scoir/components-core/dist/components/OpaqueDropdownMenuItem'
import OpaqueDropdownToggle from '@scoir/components-core/dist/components/OpaqueDropdownToggle'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Dropdown, MenuItem } from 'react-bootstrap'

import InboxItem from './InboxItem'
import NotificationCountBadge from './NotificationCountBadge'
import './index.scss'

const DEFAULT_INBOX = []

class Inbox extends React.Component {
  static propTypes = {
    theme: PropTypes.oneOf(['dark', 'light']).isRequired,
    realtimeUpLinkFn: PropTypes.func.isRequired,
    destinations: InboxItem.propTypes.destinations,
    onRetrieve: PropTypes.func,
    onMarkAsRead: PropTypes.func,
    onViewHtmlMessage: PropTypes.func,
    onDismiss: PropTypes.func,
    htmlNotificationComponent: PropTypes.func,
  }

  state = {
    inbox: DEFAULT_INBOX,
  }

  componentDidMount() {
    this.props.realtimeUpLinkFn((inboxUpdate) => {
      this.setState({
        unreadInboxCount: inboxUpdate.UnreadNotificationCount,
      })
    })
    this.fetchInboxSummary()
  }

  fetchInboxSummary() {
    return this.props.onRetrieve().then((inbox) => {
      this.setState({
        unreadInboxCount: inbox.UnreadCount,
        allInboxCount: inbox.MessageCount,
      })
      return inbox
    })
  }
  updateInbox() {
    this.setState({
      inbox: DEFAULT_INBOX,
    })
    this.fetchInboxSummary().then((inbox) => {
      this.setState({
        inbox: inbox.Messages,
      })
    })
  }
  markNotificationAsRead(item) {
    this.props
      .onMarkAsRead(item)
      .then(() => this.fetchInboxSummary())
      .then((inbox) => {
        this.setState({
          inbox: inbox.Messages,
        })
      })
  }
  dismissInboxNotification(item) {
    this.props
      .onDismiss(item)
      .then(() => this.fetchInboxSummary())
      .then((inbox) => {
        this.setState({
          inbox: inbox.Messages,
        })
      })
  }

  render() {
    return (
      <Dropdown
        className={cn('notifications', `${this.props.theme}-skin`)}
        id="menu-navigation-notifications-dropdown"
        componentClass="span"
        pullRight
        onToggle={(isOpen) => isOpen && this.updateInbox()}
      >
        <OpaqueDropdownToggle
          className="notification-toggle"
          bsRole="toggle"
        >
          <NotificationCountBadge
            unreadInboxCount={this.state.unreadInboxCount}
            theme={this.props.theme}
          />
        </OpaqueDropdownToggle>
        <Dropdown.Menu>
          <MenuItem
            header
            className="notifications-header"
          >
            {this.state.allInboxCount || 0} Messages
          </MenuItem>
          {this.state.inbox.map((item, idx) => {
            return (
              <OpaqueDropdownMenuItem key={item.Id}>
                <InboxItem
                  item={item}
                  destinations={this.props.destinations}
                  onDismiss={() => this.dismissInboxNotification(item)}
                  htmlNotificationComponent={this.props.htmlNotificationComponent}
                  onMarkAsRead={() => this.markNotificationAsRead(item, idx)}
                />
              </OpaqueDropdownMenuItem>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default Inbox
